import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as styles from "../../pages/ApplicationAccess/UploadeRequest/UploadRequest.module.scss";
import { useNavigate } from "react-router-dom";
import FileUploader from "./HandleFileSelect";
import Button from "../Common/CprimeButton";

interface UploadRequestProps {
  open: boolean;
  onClose: () => void;
  appId: number;
}
type Step = "upload" | "processing" | "done";

function UploadRequestDialog({ open, onClose, appId }: UploadRequestProps) {
  const [isSubmitDisable, setIsSubmitDisable] = useState(true);
  const [uploadId, setUploadId] = useState("");
  const [step, setStep] = useState<Step>("upload");
  const scssClass = styles as any;
  const navigate = useNavigate();

  // const checkFileUploadStatus = () => {};

  // useEffect(() => {
  //   checkFileUploadStatus();
  // }, []);

  return (
    <Dialog
      open={open}
      // onClose={() => onClose()}
      fullWidth
      maxWidth={`md`}
      sx={{
        "& .MuiDialogContent-root": {
          paddingBottom: "0.5rem !important",
          paddingTop: "0px !important",
          paddingLeft: "1.5rem !important",
          paddingRight: "1.5rem !important",
        },
      }}
    >
      <div
        style={{
          maxWidth: "945px",
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: 400,
            fontSize: "1.5rem",
            lineHeight: "2rem",
            color: "#000000",
          }}
        >
          Upload File
          <IconButton onClick={() => onClose()} data-testid="closemodal">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <div style={{ maxHeight: "calc(100vh - 200px)", width: "100%" }}>
            <FileUploader
              setIsSubmitEnabled={(param) => {
                if (param) setUploadId(param);
                setIsSubmitDisable(false);
              }}
              step={step}
              setStep={setStep}
              appId={appId}
            />
            <div className={scssClass.divider} />
            <div className={scssClass.responsiveCard}>
              <div className={scssClass.modalFooterButtonSection}>
                <div style={{ fontSize: "12px", color: "#58595B" }}>
                  {step === "done" ? 1 : 0}/1 files uploaded
                </div>
                <div className={scssClass.buttonSection}>
                  <Button
                    variant="tertiary"
                    sx={{ marginLeft: "4px", marginRight: "4px" }}
                    onClick={() => onClose()}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    disabled={isSubmitDisable}
                    sx={{ marginLeft: "4px", marginRight: "4px" }}
                    onClick={() =>
                      navigate(
                        `/application-list/app-${appId}/promote/import?uploadId=${uploadId}&type=import`,
                      )
                    }
                  >
                    Upload
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </div>
    </Dialog>
  );
}

export default UploadRequestDialog;
